import { Container } from '../types';
import normalizeContainerType from './normalizeContainerType';

export const getContainerTypes = (containers: Container[]) => {
  const containerTypes = [...new Set(containers.map((container) => normalizeContainerType(container.type)))] as Container['type'][];
  return containerTypes;
};

export const getContainersByContainerType = (containers: Container[], type: Container['type']) => {
  const filteredContainers = containers.filter((container) => normalizeContainerType(container.type) === type);
  const sortedContainers = filteredContainers.sort((a, b) => Number(a.distance) - Number(b.distance));
  return sortedContainers;
};

export const sortContainerTypeList = (containerTypes: Container['type'][]) => {
  const order: Container['type'][] = [
    'REST',
    'PBD',
    'PAPIER',
    'GFT',
    'GLAS',
    'TEXTIEL',
    'ABS',
    'KRINGLOOP',
  ];

  return order.filter((type) => {
    return containerTypes.includes(type);
  });
};
